import styled, { css } from 'styled-components';
import bgBannerOfferPro from '@/media/studio/banner-offer-pro.png';

export const BannerOfferPro = styled.div`
  ${({ theme }) => css`
    background: #f9f9f9;
    border-radius: 16px;
    display: flex;
    flex-direction: column-reverse;
    font-family: ${theme.v2.font.family.primary};
    padding: 0 20px 24px;
    overflow: hidden;
    width: 100%;

    @media (min-width: ${theme.v2.breakpoints.sm}) {
      gap: 32px;
      justify-content: center;
      flex-direction: row;
      padding: 0 0 0 20px;
    }

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      gap: 80px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      border-radius: 0;
    }
  `}
`;

export const WrapperText = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    max-width: 438px;
    width: 100%;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      min-height: 415px;
      padding: 40px 0 0 24px;
    }

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      min-height: 430px;
      padding: 48px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: none;
      align-self: center;
      padding: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 24px 0 0;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    font-size: 40px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 1.2;
    margin-bottom: 14px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: 32px;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
      margin-bottom: 16px;
    }
  `}
`;

export const Text = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    line-height: 1.5;
    margin-bottom: 24px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      margin-bottom: 16px;
    }
  `}
`;

export const WrapperImage = styled.div`
  ${({ theme }) => css`
    background: url(${bgBannerOfferPro}) no-repeat;
    background-position: left top;
    background-size: cover;
    max-width: 776px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background-position: left center;
      padding-top: 57.603092784%;
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0 16px 16px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      background-position: center center;
      background-size: contain;
    }
  `}
`;

export const WrapperButton = styled.div`
  display: flex;
  width: 100%;
`;
